import axios from 'axios';
import * as qs from 'qs';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { defaultValue, ITableType } from 'app/shared/model/commission-housing-configment.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { cleanEntity } from 'app/shared/util/entity-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_REPORTMENT_LIST: 'housing/FETCH_REPORTMENT_LIST', // 列表
  DELETE: 'housing/FETCH_DELETE',
  RESET: 'housing/RESET' // 重置
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITableType>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type cHousingState = Readonly<typeof initialState>;

// Reducer
export default (state: cHousingState = initialState, action): cHousingState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REPORTMENT_LIST):
    case REQUEST(ACTION_TYPES.DELETE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case FAILURE(ACTION_TYPES.FETCH_REPORTMENT_LIST):
    case FAILURE(ACTION_TYPES.DELETE):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.DELETE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case SUCCESS(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data || [],
        totalItems: parseInt(action.payload.data['totalElements'], 10)
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = '/fy/house-visibility';
// 列表
export const getEntities: ICrudGetListAction<ITableType> = (page, size, sort = '', searchForm) => {
  const requestUrl = `${apiUrl}/list`;
  return {
    type: ACTION_TYPES.FETCH_REPORTMENT_LIST,
    payload: axios.get<ITableType>(`${requestUrl}`),
    meta: { transformUserName: true }
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

// 创建
export function createInfo(entity) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save`, cleanEntity(entity))
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        const errorData = error.response && error.response.data ? error.response.data : error;
        reject(errorData);
      });
  });
}

// 更新
export function updateInfo(entity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${apiUrl}/update`, cleanEntity(entity))
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 日志
// export function getLog(id) {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(`${apiUrl}/${id}/log/list`)
//       .then(response => {
//         resolve(response.data);
//       })
//       .catch(() => {
//         reject();
//       });
//   });
// }
// 删除
export const deleteEntity = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}/delete`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE,
    payload: axios.delete(requestUrl)
  });
  return result;
};
